import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { Query } from '@apollo/client/react/components';

import LoadingProgress from 'lib/react-router/loading-progress';

import ErrorPage from 'four-nets/errors/error-page';

import CollectionNode from '../../collections/collection-node/collection-node';
import query, {
    RecommendedCollectionQuery,
    RecommendedCollectionQueryVariables,
} from './recommended-collections-loader.graphql';
import defaultStyles from './recommended-collections-loader.scss';

export interface Props {
    styles: typeof defaultStyles;
}

class RecommendedCollections extends React.PureComponent<Props> {
    render() {
        const { styles } = this.props;

        return (
            <Query<RecommendedCollectionQuery, RecommendedCollectionQueryVariables>
                query={query}
                variables={{
                    first: 6,
                    modifiedAfterNDays: 31,
                }}
            >
                {({ loading, error, data }) => (
                    <LoadingProgress loading={loading}>
                        <ErrorPage error={error}>
                            {data && data.collections && data.collections.edges && data.collections.edges.length ? (
                                <div className={styles.container}>
                                    <FormattedMessage id='RECOMMENDED_COLLECTIONS'>
                                        {msg => <p className={styles.header}>{msg}</p>}
                                    </FormattedMessage>
                                    <ul className={styles.recommendedCollections}>
                                        {data.collections.edges.map(edge => {
                                            if (!edge || !edge.node) {
                                                return null;
                                            }
                                            return (
                                                <li className={styles.recommendedCollection} key={edge.node.id}>
                                                    <CollectionNode {...edge.node} />
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            ) : null}
                        </ErrorPage>
                    </LoadingProgress>
                )}
            </Query>
        );
    }
}

export default Styled(defaultStyles)(RecommendedCollections);
